import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';

/**
 * Service skeleton. This service is able to manipulate local and session storages
 */
@Injectable()
export abstract class AbstractService {

  protected name: string;

  constructor(private local: LocalStorageService, private session: SessionStorageService) {
  }

  public setLocal(key: string, value: any): void {
    this.local.set(this.getKey(key), value);
  }

  public setSession(key: string, value: any): void {
    this.session.set(this.getKey(key), value);
  }

  public getLocal(key: string): any {
    return this.local.get(this.getKey(key));
  }

  public setDirectLocal(key: string, value: any): any {
    return this.local.set(key, value);
  }

  public getDirectLocal(key: string): any {
    return this.local.get(key);
  }

  public removeLocal(key: string): void {
    this.local.remove(this.getKey(key));
  }

  public getSession(key: string): any {
    return this.session.get(this.getKey(key));
  }

  private getKey(key: string) {
    return 'REGO_' + this.name + '_' + key;
  }

  protected clearLocal() {
    this.local.clear();
  }
}
